import React from 'react';
import { theme } from '../../theme';

// Pill tab row with optional count badge per tab. Active tab uses the primary
// orange so it visually anchors the page section the user is currently in.
//
// Props:
//   tabs    [{ key, label, count?, icon? }]
//   active  currently selected key
//   onChange (key) => void
//   variant 'underline' (Swipe-default) | 'pills'
export default function TabBar({ tabs, active, onChange, variant = 'underline' }) {
  if (variant === 'pills') {
    return (
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
        {tabs.map((t) => {
          const isActive = active === t.key;
          return (
            <button
              key={t.key}
              onClick={() => onChange(t.key)}
              style={{
                padding: '8px 16px',
                borderRadius: '20px',
                border: 'none',
                cursor: 'pointer',
                fontWeight: '600',
                fontSize: '0.84rem',
                backgroundColor: isActive ? theme.primary : '#eef0f3',
                color: isActive ? '#fff' : theme.textMuted,
                display: 'inline-flex', alignItems: 'center', gap: '6px',
                transition: 'all 0.12s',
              }}
            >
              {t.icon}
              {t.label}
              {t.count != null && (
                <span style={{
                  padding: '1px 8px', borderRadius: '12px', fontSize: '0.72rem', fontWeight: '700',
                  backgroundColor: isActive ? 'rgba(255,255,255,0.25)' : theme.primary + '18',
                  color: isActive ? '#fff' : theme.primary,
                }}>{t.count}</span>
              )}
            </button>
          );
        })}
      </div>
    );
  }

  // Underline variant — Swipe's signature look
  return (
    <div style={{ display: 'flex', gap: '4px', borderBottom: `1px solid ${theme.border}`, marginBottom: '14px' }}>
      {tabs.map((t) => {
        const isActive = active === t.key;
        return (
          <button
            key={t.key}
            onClick={() => onChange(t.key)}
            style={{
              padding: '10px 18px',
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
              fontWeight: '600',
              fontSize: '0.86rem',
              color: isActive ? theme.navy : theme.textMuted,
              borderBottom: isActive ? `2.5px solid ${theme.primary}` : '2.5px solid transparent',
              marginBottom: '-1px',
              display: 'inline-flex', alignItems: 'center', gap: '6px',
              transition: 'color 0.12s',
            }}
          >
            {t.icon}
            {t.label}
            {t.count != null && (
              <span style={{
                padding: '1px 7px', borderRadius: '10px', fontSize: '0.7rem', fontWeight: '700',
                backgroundColor: isActive ? theme.primary + '18' : '#eef0f3',
                color: isActive ? theme.primary : theme.textMuted,
              }}>{t.count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
